export const ga4Event = (eventName, data) => {
    return typeof window !== "undefined" && window?.gtag ? window.gtag("event", eventName, { ...data }) : console.log('no ga4')
}